import React, { Component } from 'react'

import { Formik, Form } from 'formik'
import { connect } from 'react-redux'
import { Notification } from 'react-notification'

import { getCurrentSubCategory, getSpecifications } from 'SRC/modules/categories/selectors'
import { getIsAuthorized } from 'SRC/modules/users/Auth/selectors'
import { getUserInfo, getHasAgents } from 'SRC/modules/users/Profile/selectors'

import {
  BrandProductServices,
  AdType,
  Photos,
  EquipmentNew,
  TitleNew,
  Condition,
  CompatibilityNew,
  Geo,
  SpecificationsNew,
  PriceSwappDescription,
  AgentNew
} from 'SRC/modules/ads/shared/components/FormElements'

import { getValidationSchema } from 'SRC/modules/ads/shared/functions'

import { setError } from 'SRC/modules/ads/add/actions'
import { getError, getWasSentSms, getActiveTab } from 'SRC/modules/ads/add/selectors'

import { getInitialValues } from './functions'

import { PromoPeriods } from '../PromoPeriodsNew'
import { AuthAndRegistrationForm } from '../AuthAndRegisterForm'
import { SmsCode } from '../SmsCode'

const DetailForm = ({
  currentSubCategory,
  specifications,
  defaultSpecification,
  isAuthorized,
  userInfo,
  hasPriceFromToAddon,
  hasDeliveryAddon,
  hasPriceOnRequestAddon,
  hasAdTitleAddon,
  hasAgents,
  onSubmit,
  formError,
  wasSentSms,
  activeTab,
  setError
}) => {
  const [compUniversalSelected, setCompUniversalSelected] = React.useState(false)

  const hasPriceSpecification = currentSubCategory && currentSubCategory.hasPriceSpecification

  const isActiveRegistrationTab = activeTab === 'register'

  return (
    <Formik
      initialValues={
        getInitialValues({
          currentSubCategory,
          isAuthorized,
          userInfo,
          specifications,
          hasPriceFromToAddon,
          hasDeliveryAddon,
          hasPriceOnRequestAddon,
          hasAdTitleAddon,
          hasAgents,
          defaultSpecification
        })
      }
      validationSchema={getValidationSchema({
        category: currentSubCategory,
        categorySpecifications: specifications,
        formType: 'addDetail',
        isAuthorized,
        compUniversalSelected,
        activeTab
      })}
      validateOnBlur={false}
      // validateOnChange={false}
      onSubmit={onSubmit}
      enableReinitialize
    >
      {formikProps => {
        return (
          <Form className='dodavanje-oglasa-form-podaci'>
            <Photos />
            
            {/* Ad Type */}
						<AdType />

            <div className='ads-add__pre-specifications'>
              {/* Brand, Products, Services, Service Types */}
              <BrandProductServices />

              {/* Specifications */}
							<SpecificationsNew key='specs_1' formType='addDetail' showOnlySpecs={['Oznaka']}  />
              
              {/* Condition */}
              {currentSubCategory && currentSubCategory.condition ? <Condition /> : null}
            </div>

            <TitleNew
              hasAdTitleAddon={hasAdTitleAddon}
              placeholder={currentSubCategory && currentSubCategory.fillerText ? currentSubCategory.fillerText : ''}
            />

            <div className='ads-add__post-specifications'>
              {/* Specifications */}
							<SpecificationsNew key='specs_2' formType='addDetail' hideSpecs={['Oznaka']} />
            </div>

            {/* Equipment */}
            <div className='ads-add__equipment'>
              <EquipmentNew />
            </div>

            {/* Compatibility */}
            {currentSubCategory && currentSubCategory.compatibilityCategories && currentSubCategory.compatibilityCategories.length
              ? (
                <CompatibilityNew onUniversal={isSelected => {
                  setCompUniversalSelected(isSelected)
                  setTimeout(() => formikProps.setFieldValue('compatibilityUniversality', isSelected), 1)
                }}
                />
              ) : null
            }

            {/* Geo */}
            <Geo />

            {/* Price, Description, Swapps */}
            <PriceSwappDescription
              hasPriceFromToAddon={hasPriceFromToAddon}
              hasPriceOnRequestAddon={hasPriceOnRequestAddon}
              hasDeliveryAddon={hasDeliveryAddon}
            />

            {/* Agent */}
            {hasAgents ? <AgentNew /> : null}

            <PromoPeriods />

            {!isAuthorized ? <AuthAndRegistrationForm /> : null}
            {!isAuthorized && wasSentSms && isActiveRegistrationTab ? <SmsCode /> : null}

            {!wasSentSms || (wasSentSms && !isActiveRegistrationTab)
              ? (
                <button
                  key='submit'
                  className='btn-oglas-submit ads-add__submit' type='submit'
                  disabled={!formikProps.dirty || formikProps.isSubmitting}
                  onClick={e => {
                    e.preventDefault()

                    if (!formikProps.isValid) {
											console.log('fp not valid', formikProps)
                      setError('Podaci nisu pravilno popunjeni. Polja sa * su obavezna.')
                    }

                    formikProps.handleSubmit()
                  }}
                >
                  Pošalji oglas
                </button>
              ) : null
            }

            <Notification
              isActive={Boolean(formError)}
              message={formError || ``}
              action={'Sakrij'}
              onClick={() => setError('')}
            />
          </Form>
        )
      }}
    </Formik>
  )
}

const mapStateToProps = state => {
	const currentSubCategory = getCurrentSubCategory(state)

	/**
   * Check agents
   */
	const userHasAgents = getHasAgents(state)
	const categoryHasAgents = currentSubCategory && currentSubCategory.hasAgents

	const hasAgents = userHasAgents && categoryHasAgents

	return {
		currentSubCategory,
		specifications: getSpecifications(state),
		isAuthorized: getIsAuthorized(state),
		userInfo: getUserInfo(state),
		hasAgents,
    formError: getError(state),
    wasSentSms: getWasSentSms(state),
    activeTab: getActiveTab(state)
	}
}


export default connect(mapStateToProps, { setError })(DetailForm)
